import React from "react";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

import { useUnsavedChanges } from "~/providers/unsaved-changes-provider";
import { useShiftStore } from "~/stores/use-shift-store";
import { Button } from "../ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import DayForm from "./day-form";

export default function DayDialog() {
  const { t } = useTranslation("common");

  const { selectedDate, shiftStatusFormOpen, setShiftStatusFormOpen } =
    useShiftStore();
  const { checkUnsavedChanges } = useUnsavedChanges();

  const handleDialog = (open: boolean, force?: boolean) => {
    if (open === false) {
      if (force !== true) {
        const result = checkUnsavedChanges();
        if (result === true) return;
      }
    }
    setShiftStatusFormOpen(open);
  };

  if (!selectedDate) return;

  return (
    <Dialog open={shiftStatusFormOpen} onOpenChange={handleDialog}>
      <DialogContent className="max-w-xl w-full min-h-[60vh] overflow-hidden">
        <DialogHeader>
          <DialogTitle>{format(selectedDate, "dd-MM-yyyy")}</DialogTitle>
          <VisuallyHidden>
            <DialogDescription></DialogDescription>
          </VisuallyHidden>
        </DialogHeader>
        <div className="max-h-[80vh] p-4 overflow-auto relative small-scrollbar">
          <DayForm
            onClose={(force) => {
              handleDialog(false, force);
            }}
            day={selectedDate}
          />
        </div>
        <DialogFooter>
          <Button onClick={() => handleDialog(false)}>{t("cancel")}</Button>
          <Button form="day-form" type="submit" variant="success">
            {t("apply")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
